import apiCall from './api';

export const registerStudent =(userData) => {
  //  console.log("here")
  //  console.log(userData)
    return apiCall({
      method: 'POST',
      endpoint: 'auth/register/student/',
      data: userData,
    });
  };

  export const registerStudentAdmin =(userData,isAdmin,local_part) => {
    //  console.log("here")
    //  console.log(userData)
      return apiCall({
        method: 'POST',
        endpoint: `auth/register/student/?is_from_admin=${isAdmin}&local_part=${local_part}`,
        data: userData,
      });
    };

export const registerSocial =(userData) => {
    //  console.log("here")
    //  console.log(userData)
      return apiCall({
        method: 'POST',
        endpoint: 'auth/register/social/',
        data: userData,
      });
    };
    
  export const loginUser =(userData) => {
    //  console.log("here")
    //  console.log(userData)
      return apiCall({
        method: 'POST',
        endpoint: 'auth/login/',
        data: userData,
      });
    };

    export const requestPassResetUser =(userData) => {
       console.log("here")
      //  console.log(userData)
        return apiCall({
          method: 'POST',
          endpoint: 'auth/password-reset/',
          data: userData,
        });
      };
      export const confirmPassResetUser =(userData) => {
        //  console.log("here")
        //  console.log(userData)
          return apiCall({
            method: 'POST',
            endpoint: 'auth/password-reset/confirm/',
            data: userData,
          });
        };
export const getStudentUser =(userData) => {
      //  console.log("here")
      //  console.log(userData)
        return apiCall({
          method: 'GET',
          endpoint: 'auth/student_user_details/',
          data: userData,
        });
      };
  
export const getTeacherUser =(userData) => {
        //  console.log("here")
        //  console.log(userData)
          return apiCall({
            method: 'GET',
            endpoint: 'auth/teacher_user_details/',
            data: userData,
          });
        };       

export const registerTeacher =(userData) => {
  //  console.log("here")
  //  console.log(userData)
    return apiCall({
      method: 'POST',
      endpoint: 'auth/register/teacher/',
      data: userData,
    });
  };
